import LangEnum from '../../../../../../../lang/LangEnum';
import { StatusType } from '../../../../../order.types';
import { ChangeOrderStatusModalAcceptedStatus } from '../../../changeOrderStatusModal.types';

export const CHANGE_ORDER_STATUS_MODAL_BODY_MAIN_TEXT_BASED_IN_TARGET_STATUS: Record<
  ChangeOrderStatusModalAcceptedStatus,
  LangEnum
> = {
  [StatusType.CANCELED]: LangEnum.CHANGE_STATUS_BODY_MAIN_TEXT_CANCELED,
  [StatusType.REJECTED]: LangEnum.CHANGE_STATUS_BODY_MAIN_TEXT_REJECTED,
};

export const CHANGE_ORDER_STATUS_MODAL_BODY_SUB_TEXT_BASED_IN_TARGET_STATUS: Record<
  ChangeOrderStatusModalAcceptedStatus,
  LangEnum | undefined
> = {
  [StatusType.REJECTED]: undefined,
  [StatusType.CANCELED]: undefined,
};
